document.addEventListener("click", function(e){
  const add=e.target.closest('form[action*="/cart/add"] button[type="submit"]');
  if(add)setTimeout(()=>showToast("Added to cart","Your product is ready to continue with your purchase."),250);
});
function showToast(t,s){const x=document.getElementById("LumellaToast");if(!x)return;const a=document.getElementById("ToastTitle"),b=document.getElementById("ToastText");if(a)a.textContent=t;if(b)b.textContent=s;x.classList.add("show");clearTimeout(window.lt);window.lt=setTimeout(()=>x.classList.remove("show"),3500)}

function escapeHTML(s){return String(s??'').replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[c]})}

function normalizeText(s){
  return String(s||'').toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g,'')
    .replace(/[^\p{L}\p{N}\s]/gu,' ');
}

const CALMENILLA_CATEGORIES = [
  {id:'pets', terms:['dog','dogs','puppy','perro','perros','pet','pets','mascota','mascotas','cat','cats','gato','gatos','animal','animals'], words:['pet','dog','cat','puppy','feeder','water','toy','tracker','animal'], labels:['Pet care']},
  {id:'kitchen', terms:['cook','cooking','kitchen','garlic','comida','cocina','cocinar','food','recipe','meal','bake','baking'], words:['kitchen','garlic','chopper','scale','cooking','food','spoon','press','meal','baking'], labels:['Cooking']},
  {id:'study', terms:['study','school','reading','read','translate','student','estudiar','estudio','leer','desk','office','notebook'], words:['study','reading','translator','scanner','pen','notebook','desk','office'], labels:['Study']},
  {id:'home-organization', terms:['organize','organization','organise','organizar','organization','storage','store','space','home','hogar','ordenar','messy','clutter','deskspace'], words:['organizer','organization','storage','box','holder','home','desk'], labels:['Organization']},
  {id:'car', terms:['car','cars','vehicle','driving','coche','auto','conducir'], words:['car','phone','holder','seat','safety','hammer','vehicle'], labels:['Car']},
  {id:'mobile-technology', terms:['phone','mobile','smartphone','mic','microphone','telefono','teléfono','movil','móvil','bluetooth','charger','cable'], words:['phone','microphone','wireless','tracker','charger','cable','bluetooth'], labels:['Mobile technology']},
  {id:'baby-kids', terms:['baby','bebe','bebé','infant','kid','kids','child','children','niño','niños','niña','niñas'], words:['baby','feeding','silicone','bowl','spoon','kids','child'], labels:['Baby & Kids']},
  {id:'skin-care', terms:['skin','skincare','face','facial','piel','cara','serum','beauty routine'], words:['skin','face','facial','serum','beauty'], labels:['Skin Care']},
  {id:'beauty-makeup', terms:['beauty','makeup','maquillaje','cosmetic','cosmetics','hair','cabello'], words:['beauty','makeup','cosmetic','hair'], labels:['Beauty & Makeup']},
  {id:'home', terms:['home','house','hogar','cleaning','clean','limpieza','bathroom','baño'], words:['home','cleaning','clean','bathroom','kitchen'], labels:['Home']},
  {id:'viral-products', terms:['viral','trending','trend','popular'], words:['viral','trending','popular'], labels:['Viral products']}
];

function categoryForProduct(product){
  const collections = Array.isArray(product.collections) ? product.collections.map(normalizeText) : [];
  const tags = normalizeText(product.tags||'');
  const type = normalizeText(product.type||'');
  const title = normalizeText(product.title||'');
  const all = collections.concat([tags,type,title]).join(' ');
  // Prefer explicit Calmenilla collection/tag/category handles.
  for(const c of CALMENILLA_CATEGORIES){
    if(collections.includes(c.id) || tags.includes('catalog-'+c.id) || tags.includes(c.id)) return c.id;
  }
  // Fall back to product metadata for older products without collections.
  for(const c of CALMENILLA_CATEGORIES){
    if(c.terms.some(t=>all.includes(normalizeText(t)))) return c.id;
  }
  return '';
}

function detectQueryCategory(query){
  const q=normalizeText(query);
  const scores=CALMENILLA_CATEGORIES.map((c,index)=>{
    let score=0;
    c.terms.forEach(term=>{
      const t=normalizeText(term);
      if(q.includes(t)) score += t.length >= 5 ? 4 : 2;
    });
    return {c,score,index};
  }).sort((a,b)=>b.score-a.score||a.index-b.index);
  return scores[0].score>0 ? scores[0].c : null;
}

function getQueryBoosts(query){
  const q=normalizeText(query);
  const category=detectQueryCategory(q);
  return category ? category.words : [];
}

function scoreProduct(product, query, category){
  const q=normalizeText(query);
  const words=q.split(/\s+/).filter(w=>w.length>2);
  const text=normalizeText([product.title,product.tags,product.type,product.description].join(' '));
  const title=normalizeText(product.title);
  const productCategory=categoryForProduct(product);
  let score=0;
  words.forEach(word=>{
    if(text.includes(word)) score += title.includes(word)?8:2;
  });
  getQueryBoosts(query).forEach(word=>{
    if(text.includes(word)) score += title.includes(word)?7:3;
  });
  // A category match is intentionally much stronger than a loose keyword match.
  if(category && productCategory===category.id) score += 40;
  if(category && productCategory && productCategory!==category.id) score -= 25;
  return score;
}

function rankProducts(products, query){
  if(!products.length)return [];
  const category=detectQueryCategory(query);
  let pool=products;
  if(category){
    const sameCategory=products.filter(p=>categoryForProduct(p)===category.id);
    // When the catalogue has category metadata, never mix unrelated categories.
    if(sameCategory.length) pool=sameCategory;
  }
  const ranked=pool.map((p,i)=>({p,s:scoreProduct(p,query,category),i})).sort((a,b)=>b.s-a.s||a.i-b.i);
  const matched=ranked.filter(x=>x.s>0);
  return (matched.length?matched:ranked).slice(0,4).map(x=>x.p);
}

function productReason(product, query, primary){
  const category=detectQueryCategory(query);
  if(primary){
    return category
      ? 'Best match in '+category.labels[0]+' for your request.'
      : 'Best match for what you described.';
  }
  return category
    ? 'Another '+category.labels[0].toLowerCase()+' option related to your request.'
    : 'Another relevant option for your request.';
}

function renderAIResults(products, query, answer){
  if(!answer)return;
  if(!products.length){
    answer.innerHTML='<div class="ai-empty"><strong>We couldn’t find a close match yet.</strong><p>Try describing what you need in a little more detail.</p></div>';
    return;
  }
  const cards=products.map((p,i)=>{
    const image=p.image?'<img src="'+escapeHTML(p.image)+'" alt="'+escapeHTML(p.title)+'">':'';
    return '<article class="ai-answer-card '+(i===0?'is-primary':'')+'">'+
      '<div class="ai-answer-image">'+image+'</div>'+
      '<div class="ai-answer-copy">'+
        '<div class="eyebrow">'+(i===0?'BEST MATCH':'RELEVANT OPTION')+'</div>'+
        '<h3 title="'+escapeHTML(p.title||'Product')+'">'+escapeHTML(p.title||'Product')+'</h3>'+
        '<p class="ai-product-reason">'+escapeHTML(productReason(p,query,i===0))+'</p>'+
        '<a class="btn btn-primary" href="'+escapeHTML(p.url||'#')+'">View product · '+escapeHTML(p.price||'')+'</a>'+ 
      '</div></article>';
  }).join('');
  answer.innerHTML='<div class="ai-results-heading"><strong>We found '+products.length+' relevant options</strong><span>Starting with the best match.</span></div><div class="ai-results-grid">'+cards+'</div>';
}

document.addEventListener('DOMContentLoaded',function(){
  const btn=document.querySelector('.catalog-toggle');
  const menu=document.getElementById('LumellaCatalogMenu');
  if(btn&&menu){btn.addEventListener('click',function(){const open=btn.getAttribute('aria-expanded')==='true';btn.setAttribute('aria-expanded',String(!open));menu.hidden=open;btn.classList.toggle('is-open',!open);});}

  /* Hero product rotation */
  document.querySelectorAll('[data-hero-carousel]').forEach(function(carousel){
    const slides=Array.from(carousel.querySelectorAll('.hero-product-slide'));
    const dots=Array.from(carousel.querySelectorAll('.hero-dot'));
    if(slides.length<2)return;
    let index=0;
    function show(i){slides[index].classList.remove('is-active');if(dots[index])dots[index].classList.remove('is-active');index=(i+slides.length)%slides.length;slides[index].classList.add('is-active');if(dots[index])dots[index].classList.add('is-active');}
    let timer=setInterval(()=>show(index+1),4200);
    carousel.addEventListener('mouseenter',()=>clearInterval(timer));
    carousel.addEventListener('mouseleave',()=>timer=setInterval(()=>show(index+1),4200));
  });

  /* Viral marquee */
  document.querySelectorAll('[data-viral-marquee]').forEach(function(el){
    const track=el.querySelector('.viral-track');if(!track)return;
    let down=false,startX=0,startTransform=0;
    el.addEventListener('pointerdown',function(e){down=true;el.setPointerCapture(e.pointerId);startX=e.clientX;const m=getComputedStyle(track).transform;startTransform=(m&&m!=='none')?new DOMMatrix(m).m41:0;track.style.animationPlayState='paused';});
    el.addEventListener('pointermove',function(e){if(!down)return;track.style.transform='translateX('+(startTransform+e.clientX-startX)+'px)';});
    ['pointerup','pointercancel'].forEach(evt=>el.addEventListener(evt,function(){down=false;track.style.transform='';track.style.animationPlayState='running';}));
  });

  /* Problem -> solution */
  const result=document.getElementById('CalmenillaSolutionResult');
  const solutionImage=document.getElementById('SolutionImage');
  const solutionTitle=document.getElementById('SolutionTitle');
  const solutionReason=document.getElementById('SolutionReason');
  const solutionLink=document.getElementById('SolutionLink');
  const dbNode=document.getElementById('CalmenillaProductDatabase');
  let products=[];
  if(dbNode){try{products=JSON.parse(dbNode.textContent||'[]')}catch(e){products=[];}}

  function showSolution(title,text,keywords){
    const ranked=rankProducts(products,(title||'')+' '+(text||'')+' '+(keywords||''));
    const p=ranked[0];if(!p||!result)return;
    document.querySelectorAll('.solution-problem-card').forEach(c=>c.classList.toggle('is-selected',c.dataset.problem===title));
    solutionTitle.textContent=p.title||'Product';
    solutionReason.textContent='This product is the closest match for “'+title+'” in our catalogue.';
    solutionLink.href=p.url||'#';
    solutionImage.innerHTML=p.image?'<img src="'+escapeHTML(p.image)+'" alt="'+escapeHTML(p.title||'')+'">':'';
    result.hidden=false;
    result.classList.remove('solution-pop');void result.offsetWidth;result.classList.add('solution-pop');
    result.scrollIntoView({behavior:'smooth',block:'nearest'});
  }
  document.querySelectorAll('.solution-problem-card').forEach(btn=>btn.addEventListener('click',()=>showSolution(btn.dataset.problem,btn.dataset.problemText,btn.dataset.problemKeywords)));
  const close=document.querySelector('.solution-close');if(close)close.addEventListener('click',()=>result.hidden=true);

  /* Calmenilla AI: primary recommendation + 3 relevant alternatives */
  const aiForm=document.getElementById('CalmenillaAIForm');
  const aiInput=document.getElementById('CalmenillaAIInput');
  const aiAnswer=document.getElementById('CalmenillaAIAnswer');
  function askAI(text){renderAIResults(rankProducts(products,text),text,aiAnswer);}
  if(aiForm)aiForm.addEventListener('submit',function(e){e.preventDefault();const value=aiInput&&aiInput.value.trim();if(value)askAI(value);});
  document.querySelectorAll('[data-ai-suggestion]').forEach(b=>b.addEventListener('click',function(){if(aiInput){aiInput.value=b.dataset.aiSuggestion;askAI(aiInput.value);}}));
});
